export default __webpack_public_path__ + "static/media/document_error.b1cd3156.svg";